import _ from 'lodash'
import api, { listDehydrate, formCfg } from './api'

const secondarySource = {
  getList(params, context) {
    return api
      .get('/api/polls/secondary_source/', formCfg(params, context))
      .then((response) => listDehydrate(response.data, dehydrate))
      .then((response) => _.sortBy(response, ['pk']))
  },
}

export function dehydrate({ pk, title }) {
  return { pk, title }
}

export default secondarySource
